import { render, staticRenderFns } from "./MessagingStep.vue?vue&type=template&id=382975d5"
import script from "./MessagingStep.vue?vue&type=script&lang=js"
export * from "./MessagingStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports